export const getters = {
  horaires (state) {
     console.log(state.horaires);
    return state.horaires
  },
  horaire (state) {
    return state.horaire
  },  
  pagination(state){
    console.log(state.pagination);
    return state.pagination
  }
}
